import { getInvoiceMeta, getInvoicePaymentMethods, payInvoice } from './action'
import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

const initialState: Invoice.InvoiceState = {
  meta: {
    status: 'none',
    data: null,
    error: null
  },
  paymentMethods: {
    status: 'none',
    data: []
  },
  checkoutResults: {
    status: 'none',
    data: null
  }
}

export const invoiceSlice = createSlice({
  name: '@invoice',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getInvoiceMeta.pending, (state) => {
        state.meta.status = 'pending'
      })
      .addCase(getInvoiceMeta.fulfilled, (state, action) => {
        state.meta.status = 'fulfilled'
        state.meta.data = action.payload.data
      })
      .addCase(getInvoiceMeta.rejected, (state, action) => {
        state.meta.status = 'rejected'
        state.meta.error = action.payload
      })
      .addCase(getInvoicePaymentMethods.pending, (state) => {
        state.paymentMethods.status = 'pending'
      })
      .addCase(getInvoicePaymentMethods.fulfilled, (state, action) => {
        state.paymentMethods.status = 'fulfilled'
        state.paymentMethods.data = action.payload.payload.paymentOptions
      })
      .addCase(getInvoicePaymentMethods.rejected, (state, action) => {
        state.paymentMethods.status = 'rejected'
        state.paymentMethods.error = action.error.message
      })
      .addCase(payInvoice.pending, (state) => {
        state.checkoutResults.status = 'pending'
      })
      .addCase(payInvoice.fulfilled, (state, action) => {
        state.checkoutResults.status = 'fulfilled'
        state.checkoutResults.data = action.payload
      })
      .addCase(payInvoice.rejected, (state, action) => {
        state.checkoutResults.status = 'rejected'
        state.checkoutResults.error = action.error.message
      })
      .addCase(HYDRATE, (state, action) => ({
        ...state,
        ...action['payload']['@invoice']
      }))
})
